import React from 'react';
import { ListChecks, Plus } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/Card/Card';
import { Button } from '@/components/ui/Button/Button';

interface EmptyShortlistStateProps {
  onAddHotel?: () => void;
}

export function EmptyShortlistState({ onAddHotel }: EmptyShortlistStateProps) {
  return (
    <Card>
      <CardContent className="py-12 text-center">
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center">
            <ListChecks className="w-8 h-8 text-gray-400" />
          </div>
        </div>
        <h3 className="text-lg font-semibold mb-2">Your Shortlist is Empty</h3>
        <p className="text-muted-foreground max-w-sm mx-auto mb-4">
          Search for venues and add them to your shortlist, or add a specific hotel manually.
        </p>
        {onAddHotel && (
          <Button
            variant="outline"
            size="sm"
            leftIcon={<Plus className="w-4 h-4" />}
            onClick={onAddHotel}
          >
            Add Hotel
          </Button>
        )}
      </CardContent>
    </Card>
  );
}
